import styled from 'styled-components'

export const ContainerCollection = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 2rem;
    section {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-around;
        p {
            margin-top: 1rem;
        }
    }
    .button {
        background-color: var(--background-season-2);
        width: 325px;
        height: 43px;
        align-self: center;
        text-align: -webkit-center;
        margin-top: 0px;
        padding-top: 10px;
        padding-bottom: 10px;
        border-radius: 26px;
        margin-top: 5rem;
        a {
            color: var(--text-title);
            font-family: 'Graphik';
            font-style: normal;
            font-weight: 700;
            font-size: 20px;
            line-height: 20px;
        }
    }
    .texts {
        margin-top: 3rem;
        margin-bottom: 4rem;

        p {
            font-size: 18px;
            margin-bottom: 1rem;

        }
        p + p {
            font-family: Moby;
        }
    }

    @media(max-width: 1024px) {
        section div {
        margin-left: 0rem;
        }
    }
    
    @media(max-width: 768px) {
        img {
            max-width: 90vw;
        }
    }

    @media(max-width: 425px){
        img {
            margin-left: 0.5rem;
            margin-right: 0;
        }
        .button {
            width: 267px;
        }
        .texts {
            p  {
                font-size: 16px;
                margin-left: 1rem;
            }
        }
        section p {
            margin-left: 2rem;
        }
    }


    @media(max-width: 382px) {
        .button a {
            font-size: 22px;
        }
        .button {
            height: 52px;
            padding-top: 13px;
        }
    }

`